import axios from "axios";

// const baseURL = process.env.VUE_APP_API_BASE_URL || window.location.origin;
// const baseURL = "https://havaianas-confi.mbsi.com.ph";
// const baseURL = "https://staff.mbsi.com.ph";
// const baseURL = "https://localhost:5001";
// const baseURL = "https://evaair.mbsi.com.ph";
// const baseURL = "https://terrysa.mbsi.com.ph";
const baseURL = "https://quadrant.mbsi.com.ph";
// const baseURL = "https://galderma.mbsi.com.ph";

export default axios.create({
  baseURL,
L: baseURL,
L: baseURL,
L: baseURL,
L: baseURL,
L: baseURL,
  // You can add your headers here
});
